<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="fastRect">
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>服务</span></div>
        <div class="van-cell__value"><van-checkbox v-model="data.isFastService" disabled :checked-color="GetColorMain()">急速认证 (5分钟内出证)</van-checkbox></div>
      </div>
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>实体卡</span></div>
        <div class="van-cell__value"><van-checkbox v-model="data.isPhysicsCard" disabled :checked-color="GetColorMain()">潜店定制潜水卡</van-checkbox></div>
      </div>
      <FieldSelect v-model="moneyChannelId" :list="columnsPayType" label="支付方式" placeholder="请选择支付方式" @change="onPayTypeChange" />
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>价格</span></div>
        <div class="van-cell__value" style="text-align:left">￥{{ ShowMoney(data.priceAll) }}</div>
      </div>
      <div v-if="payPoundage>0" class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>支付手续费</span></div>
        <div class="van-cell__value" style="text-align:left">￥{{ ShowMoney(data.priceAll*payPoundage) }}<br>(更换支付方式无手续费)</div>
      </div>
    </div>
    <div class="downButton">
      <van-button type="danger" :color="GetColorMain()" style="width:100%" :loading="buttonLoading" @click="onPay">立即支付</van-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Field, Switch, Popup, Checkbox } from 'vant'
import TopBar from '@/components/TopBar'
import { GetEnumList, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import FieldSelect from '@/components/FieldSelect'
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Switch.name]: Switch,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    TopBar,
    FieldSelect
  },
  data() {
    return {
      titleTop: '',
      title: '支付',
      backurl: '/store/index',
      picId: undefined,
      columnsPayType: [],
      buttonLoading: false,
      moneyChannelId: undefined,
      data: {
      },
      payPoundage: 0
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.picId = this.$route.params.id
    this.getWechatPayPoundage()
    this.init(() => {
      this.columnsPayType = []
      request({
        url: '/Store/GetPAYChannel',
        method: 'post',
        data: {
          isSystem: true
        }
      }).then(Response => {
        if (!Response.success) {
          return
        }
        this.columnsPayType = Response.data
        this.columnsPayType.forEach(el => {
          el.text = el.name
          el.value = el.moneyChannelId
        })
        if (this.columnsPayType.length > 0) {
          this.onPayTypeChange(this.columnsPayType[0])
        }
      })
    })
  },
  methods: {
    GetEnumList,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onPay() {
      this.buttonLoading = true
      request({
        url: '/Pro/picPay',
        method: 'post',
        data: { picId: this.picId,
          moneyChannelId: this.moneyChannelId }
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        this.$router.push('/store/pay/0?id=' + Response.data)
      })
    },
    init(callback) {
      request({
        url: '/Pro/getPicById',
        method: 'post',
        params: { picId: this.picId }
      }).then(Response => {
        this.loading = true
        if (!Response.success) {
          return
        }
        this.data = Response.data
        if (callback) {
          callback()
        }
      })
    },
    getWechatPayPoundage() {
      // 暂不收支付手续费
      // request({
      //   url: '/StoreHelper/getWechatPayPoundage',
      //   method: 'post'
      // }).then(Response => {
      //   this.loading = true
      //   if (!Response.success) {
      //     return
      //   }
      //   this.payPoundage = Response.data
      // })
    },
    onPayTypeChange(select) {
      console.log('onPayTypeChange', select)
      this.moneyChannelId = select.value
      this.payPoundage = select.chargesPercentage
      if (select.isFreePayPrice) {
        this.payPoundage = 0
      }
      this.payPoundage = 0 // 暂不开放
    }
  }
}
</script>
<style scoped>
.fastRect{
    background-color: #fff;
    border-radius: 0.3em;
    padding: 0.5em;
    margin: 1em;
}
.fastRect .title{
    font-size: 1.1em;
    font-weight: 700;
    padding: 0.3em 0 0.3em 0.9em;
}
.downButton{
    margin: 1em;
}
.downButton button{
    margin-bottom: 1em;
}
</style>
